module.exports = __webpack_public_path__ + "static/img/detail3.ca91d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/detail3.png
// module id = 6h03
// module chunks = 0